// extracted by css-extract-rspack-plugin
export default {"BulkActionButton":"VV8fk","BulkActionDangerButton":"xppKA"};